<template>
  <div class="products-page">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">کاتالوگ فروش</p>
        <h1 class="mb-0">محصولات</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="productPaginationMeta && productPaginationMeta.total != null">
          <strong>{{ formatNumber(productPaginationMeta.total) }}</strong>
          <span>محصول</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="box-seam"></b-icon>
        </div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link class="products-tool-btn" :to="{ name: 'CreateProduct' }">
          <b-icon icon="plus-lg"></b-icon>
          <span>ساخت محصول</span>
        </router-link>
        <router-link class="products-tool-btn" :to="{ name: 'TrashProduct' }">
          <b-icon icon="trash"></b-icon>
          <span>سطل زباله</span>
        </router-link>
        <router-link class="products-tool-btn" :to="{ name: 'DashboardWishList', params: { user_id: userId } }">
          <b-icon icon="heart"></b-icon>
          <span>آیتم‌های موردعلاقه</span>
        </router-link>
        <template v-if="isAdmin">
          <button type="button" class="products-tool-btn" v-b-modal="'product-bulk-edit-modal'">
            <b-icon icon="sliders"></b-icon>
            <span>ویرایش گروهی</span>
          </button>
          <router-link class="products-tool-btn" :to="{ name: 'ProductBulkEdits' }">
            <b-icon icon="clock-history"></b-icon>
            <span>تاریخچه ویرایش گروهی</span>
          </router-link>
        </template>
        <data-import-manager class="products-excel-btn is-import" data-type="product"/>
        <data-export class="products-excel-btn is-export" data-type="product"/>
        <LanguageSelectBox class="products-lang" @changeLanguage="getProductItems" module-name="product"/>
      </div>
      <filters/>
    </div>

    <div v-if="isAdmin && selectedCount" class="bulk-selection-bar">
      <span class="bulk-selection-count">{{ formatNumber(selectedCount) }}</span>
      <span>محصول انتخاب شده</span>
      <button type="button" class="is-primary" v-b-modal="'product-bulk-edit-modal'">
        <b-icon icon="sliders"></b-icon>
        <span>ویرایش گروهی</span>
      </button>
      <button type="button" @click="clearSelection">
        <b-icon icon="x-lg"></b-icon>
        <span>لغو انتخاب</span>
      </button>
    </div>

    <div class="products-list-panel">
      <table-items :items="products" :loading="listLoading" :restoreState="false" :selectable="isAdmin"/>
      <div class="products-pager" v-if="!listLoading && products && products.length">
        <pagination :meta="productPaginationMeta" :on-change-page="changeProductsPage"/>
      </div>
    </div>

    <product-bulk-edit-modal v-if="isAdmin" :filter-total="productPaginationMeta ? productPaginationMeta.total : null"
                             @applied="onBulkApplied"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import tableItems from "../../components/dashboard/product/tableItems.vue";
import Pagination from "../../components/dashboard/Pagination.vue";
import Filters from "../../components/dashboard/product/Filters";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import DataImportManager from "../../components/dashboard/DataImport/DataImportManager.vue";
import DataExport from "../../components/dashboard/DataExport/DataExport.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import ProductBulkEditModal from "../../components/dashboard/product/ProductBulkEditModal.vue";
import "../../components/dashboard/product/products-ui.css";

export default {
  name: "Product",
  components: {ProductBulkEditModal, DataExport, DataImportManager, tableItems, Pagination, Filters, LanguageSelectBox},
  data() {
    return {
      listLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      productPaginationMeta: "Product/getPaginationMeta",
      userId: 'User/getUserId',
      isAdmin: 'User/isAdmin',
      selectedCount: 'ProductBulkEdit/selectedCount'
    }),
  },
  methods: {
    formatNumber,
    clearSelection() {
      this.$store.dispatch('ProductBulkEdit/clear')
    },
    onBulkApplied() {
      this.fetchProducts(this.$route.query.page || 1)
    },
    async fetchProducts(page) {
      this.listLoading = true
      try {
        await this.$store.dispatch("Product/setDashboardProducts", page)
      } finally {
        this.listLoading = false
      }
    },
    changeProductsPage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.fetchProducts(page)
    },
    async getProductItems() {
      let page = 1
      if (this.$route.query.page != undefined) {
        page = this.$route.query.page;
      }
      this.$store.commit("Product/setFilters", {key: "sort", value: 'id,desc'});
      await this.fetchProducts(page);
    },
  },
  async mounted() {
    await this.getProductItems();
  },
};
</script>

<style scoped>
.products-page {
  padding: 8px 4px 24px;
}

.products-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
  border-radius: 22px;
  padding: 24px 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  opacity: 0.8;
  font-size: 13px;
}

.products-hero h1 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 0;
}

.hero-side {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.hero-count {
  text-align: left;
}

.hero-count strong {
  display: block;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.hero-count span {
  font-size: 12px;
  opacity: 0.8;
}

.hero-badge {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

@media (max-width: 767px) {
  .products-page {
    padding: 4px 0 16px;
  }

  .products-hero {
    padding: 14px 14px;
    margin-bottom: 12px;
    border-radius: 16px;
    align-items: center;
  }

  .hero-badge {
    display: none;
  }

  .products-hero h1 {
    font-size: 22px;
  }

  .hero-count strong {
    font-size: 20px;
  }
}
</style>
